import {
  Box,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Input from "../../../../components/Input";
import ButtonComp from "../../../../components/Button";
import theme from "../../../../theme";
import WarningPopup from "../../../../components/WarningPopup";
import { downloadReport, generateReport } from "../../../../services/dashboard";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import download from "../../../../assets/images/download.svg";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import { useToast } from "../../../../hooks/useToast";
import Loader from "../../../../components/Loader";
import { useAuthStore } from "../../../../store/useAuthStore";

export default function PaymentProceed() {
  const today = new Date();

// Allow up to yesterday (disable today)
const maxSelectableDate = new Date(today);
maxSelectableDate.setDate(today.getDate());
const maxDate = maxSelectableDate.toISOString().split("T")[0];
  
const minDate = "2025-10-01";


// Still restrict up to 7 days before yesterday
// const minDate = new Date(maxSelectableDate);
// minDate.setDate(maxSelectableDate.getDate() - 6);
// const minDateStr = minDate.toISOString().split("T")[0];

  // Still restrict up to 7 days before yesterday
  // const minDate = new Date(maxSelectableDate);
  // minDate.setDate(maxSelectableDate.getDate() - 6);
  // const minDateStr = minDate.toISOString().split("T")[0];

  const [date, setDate] = useState(maxDate);
  const [reportType, setReportType] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const [warningError, setWarningError] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { first_name, last_name, user_name } = useAuthStore();
  const generatedBy =
    [first_name, last_name].filter(Boolean).join(" ") || user_name;

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    if (!selectedDate) return setDate("");

    const selected = new Date(selectedDate);

    // If date is before minDate, reset it to minDate
    // if (selected < minDate) {
    //   setShowWarning(true);
    //   setWarningError("Date cannot be older than 7 days!");
    //   setDate(minDateStr);
    //   return;
    // }

    // If date is in the future, reset to today
    if (selected >= today) {
      setShowWarning(true);
      setWarningError("Date cannot be in the future!");
      setDate(maxDate);
      return;
    }
    setDate(selectedDate);
  };

  const handleSubmit = async () => {
    if (!reportType) {
      setShowWarning(true);
      setWarningError("Please select a report type!");
      return;
    }

    setIsLoading(true);
    const response = await generateReport(generatedBy, reportType, date);
    if (response.status === 200) {
      setFileUrl(response.data.s3Path);
    } else {
      setShowWarning(true);
      setWarningError(response.data.message);
    }
    setIsLoading(false);
  };

  const handleDownload = async () => {
    try {
      const response = await downloadReport(fileUrl);
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileUrl.split("/").pop() || "report.csv";
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Failed to download report!");
    }
  };

  return (
    <Box
      overflow="hidden"
      p={{ xs: 1, sm: 2, md: 3 }}
      bgcolor="background.paper"
      height={{ xs: "auto", md: "100vh" }}
      display="flex"
      flexDirection="column"
      sx={{
        boxSizing: "border-box",
        overflowX: "auto",
      }}
    >
      {isLoading ? <Loader isLoading={isLoading} /> : null}
      <Box flexShrink={0} sx={{ marginTop: { xs: 7, sm: 0 }, mb: 3 }}>
        <Typography
          fontSize={{ xs: 18, sm: 22, md: 25 }}
          fontWeight={600}
          color="primary.main"
          textAlign="left"
        >
          Finance/Payment Proceed
        </Typography>
      </Box>
      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          background: "#ffffff",
          height: "100%",
        }}
        elevation={2}
      >
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              select
              fullWidth
              label="Select Report Type"
              variant="outlined"
              value={reportType}
              onChange={(e: any) =>
                setReportType(
                  e.target.value === "Cash Payout"
                    ? "Cash Payout"
                    : e.target.value === "Service Payout"
                    ? "Service Payout"
                    : e.target.value === "10% Payout"
                    ? "10% Payout"
                    : ""
                )
              }
              SelectProps={{
                displayEmpty: true,
                renderValue: (selected: any) =>
                  selected ? (
                    selected
                  ) : (
                    <span style={{ color: "#aaa" }}>Select Report Type</span>
                  ),
                MenuProps: {
                  PaperProps: {
                    sx: {
                      backgroundColor: "#ffffff",
                      borderRadius: "12px",
                      maxHeight: "300px",
                    },
                  },
                },
              }}
            >
              <MenuItem
                value="Cash Payout"
                sx={{
                  background: "background.default",
                  borderBottom: `1px solid ${theme.palette.grey[200]}`,
                }}
              >
                Cash Payout
              </MenuItem>
              <MenuItem
                value="Service Payout"
                sx={{
                  background: "background.default",
                  borderBottom: `1px solid ${theme.palette.grey[200]}`,
                }}
              >
                Service Payout
              </MenuItem>
              <MenuItem
                value="10% Payout"
                sx={{
                  background: "background.default",
                  borderBottom: `1px solid ${theme.palette.grey[200]}`,
                }}
              >
                10% Payout
              </MenuItem>
              {/* <MenuItem
                value="All Claims"
                sx={{
                  background: "background.default",
                  borderBottom: `1px solid ${theme.palette.grey[200]}`,
                }}
              >
                All Claims
              </MenuItem> */}
            </Input>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Input
              type="date"
              label="Select Date"
              placeholder="DD-MM-YYYY"
              variant="outlined"
              value={date}
              onChange={handleDateChange}
              inputProps={{
                min: minDate,
                max: maxDate,
              }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        <Box display="flex" justifyContent="flex-start" mt={5}>
          <ButtonComp
            variant="contained"
            height={40}
            fontSize="16px"
            width={200}
            onClick={handleSubmit}
          >
            Generate Report
          </ButtonComp>
        </Box>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4 }}>
            {fileUrl && (
              <Box mt={3}>
                <Typography
                  variant="body1"
                  sx={{ mb: 1, fontWeight: 600 }}
                  textAlign="left"
                >
                  Report Ready:
                </Typography>
                <Box
                  sx={{
                    background: "#F5EEE9",
                    color: "#FF0000",
                    borderRadius: 1,
                    px: 1.5,
                    py: 0.5,
                    display: "flex",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1} flexGrow={1}>
                    <FileCopyRoundedIcon />
                    <Box>
                      <Typography fontSize={14}>{fileUrl}</Typography>
                      <Typography
                        fontSize={12}
                        color="text.secondary"
                      ></Typography>
                    </Box>
                  </Box>

                  <IconButton size="small">
                    <img src={download} onClick={handleDownload} />
                  </IconButton>
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Paper>
      {showWarning && (
        <WarningPopup
          open={showWarning}
          onClose={() => setShowWarning(false)}
          warningError={warningError}
        />
      )}
    </Box>
  );
}
